import { updateEditorCanvasPage } from '~src/~graphql/controllers';

export const saveEditorPagesOrder = async (canvasId, pages) => {
  // Update each page with its new order
  const updatePromises = pages.map(async (page, index) => {
    if (page.objectId) {
      await updateEditorCanvasPage(page.objectId, {
        order: index,
      });
    }
  });

  // Wait for all updates to complete
  await Promise.all(updatePromises);
};
